export default "__VITE_ASSET__Db2prl1Y__";